module.exports = __webpack_public_path__ + "assets/img/shanghai_213_3.96fdf1d3.jpg";